import { useEffect, useRef, useState } from 'react';

import { boardItemInsert, boardItemUpdate, programBoardAuthDetail } from '@/network/apis/apiUri';
import { errorAlert } from '@/util';
import { transXssTitle } from '../../util/transXss';
import '../../../common/css/common_program_board_write.scss';

export default function ProgramSendMessageWrite(props) {
  const { mode, selBoard, history, handleWriteClose, itemId } = props;

  const titleRef = useRef();
  const contentRef = useRef();
  const [postData, setPostData] = useState({
    board_id: selBoard.boardId,
    title: [
      {
        lan_code: 'en',
        text: '',
      },
      {
        lan_code: 'ko',
        text: '',
      },
    ],
    content: [
      {
        lan_code: 'en',
        text: '',
      },
      {
        lan_code: 'ko',
        text: '',
      },
    ],
    open_status: {
      is_allow: true,
      start_date: null,
      end_date: null,
    },
    url_link: null,
    tag: null,
    vod: null,
    news: null,
    program: null,
    image: [],
    is_top: false,
    is_blind: true,
    file: [],
    files: [],
  });
  const [state, setState] = useState(false);

  const handleClick = (e) => {
    const { value } = e.currentTarget;

    if (value === 'public') {
      setState(false);
    } else {
      setState(true);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);

    const _title = formData.get('title') ?? '';
    const _content = formData.get('content') ?? '';
    const _isBlind = state;

    if (itemId) {
      boardItemUpdate({
        ...postData,
        title: [
          {
            lan_code: 'en',
            text: _title,
          },
          {
            lan_code: 'ko',
            text: _title,
          },
        ],
        content: [
          {
            lan_code: 'en',
            text: _content,
          },
          {
            lan_code: 'ko',
            text: _content,
          },
        ],
        is_blind: _isBlind,
      })
        .then((res) => {
          if (res.status === 200) {
            alert('Edit done');
            handleWriteClose();
          }
        })
        .catch(errorAlert);
      return;
    }
    boardItemInsert({
      ...postData,
      title: [
        {
          lan_code: 'en',
          text: _title,
        },
        {
          lan_code: 'ko',
          text: _title,
        },
      ],
      content: [
        {
          lan_code: 'en',
          text: _content,
        },
        {
          lan_code: 'ko',
          text: _content,
        },
      ],
      is_blind: _isBlind,
    })
      .then((res) => {
        if (res.status === 200) {
          alert('You have completed writing.');
          handleWriteClose();
        }
      })
      .catch(errorAlert);
  };

  const handleReset = () => {
    handleWriteClose();
  };

  useEffect(() => {
    if (itemId) {
      programBoardAuthDetail({
        board_id: selBoard.boardId,
        board_item_id: itemId,
        hit: true,
      })
        .then((res) => {
          if (res.status === 200) {
            const _data = res.data;
            setPostData(_data);
            titleRef.current.value = transXssTitle(_data.title.find((el) => el.lan_code === mode).text);
            contentRef.current.value = transXssTitle(_data.content.find((el) => el.lan_code === mode).text);

            setState(res.data.is_blind);
          }
        })
        .catch((e) => {
          if (e.response) {
            const result = e.response.data.resultCode.code;
            if (result === 401101) {
              if (mode === 'ko') alert('작성자만 확인가능합니다. 로그인 인증 후 확인해주세요.');
              if (mode === 'en') alert('Only the author can check. Please verify after logging in.');
            }
            if (result === 401002) {
              if (mode === 'ko') alert('만료된 토큰입니다. 로그인을 다시 진행해주세요.');
              if (mode === 'en') alert('This token is expired. Please log in again');
              localStorage.removeItem('userData');
            }
            if (e.reponse.status === 500) {
              if (mode === 'ko') alert('잠시후 다시 시도해 주세요.');
              if (mode === 'en') alert('Please try again in a few minutes.');
            }

            history.go(0);
          }
        });
    } else {
      titleRef.current.value = '';
      contentRef.current.value = '';
    }
  }, [itemId]);

  return (
    <div id="CommonProgramBoard" className="commonProgramBoard">
      <div className="commonProgramBoard_title-wrap">
        <h2 className="commonProgramBoard_title">{`Send Message ${itemId ? 'Edit' : 'Write'}`}</h2>
      </div>
      <form
        id="CommonProgramBoardWrite"
        className="commonProgramBoardWrite"
        onSubmit={handleSubmit}
        onReset={handleReset}
      >
        <div className="write-warp">
          <div className="write-warp_inner">
            <label htmlFor="writeTitle" className="write-warp_label">
              제목
            </label>
            <input type="text" ref={titleRef} id="writeTitle" name="title" className="write-warp_title" />
          </div>
          <div className="write-warp_inner">
            <label htmlFor="writeContent" className="write-warp_label">
              내용
            </label>
            <textarea id="writeContent" ref={contentRef} className="write-warp_content" name="content" />
          </div>
          <div className="write-warp_inner">
            <div className="write-warp_label btn">공개설정</div>
            <button type="button" value="public" className={`btn-open ${!state && 'on'}`} onClick={handleClick}>
              공개
            </button>
            <button type="button" value="private" className={`btn-open ${state && 'on'}`} onClick={handleClick}>
              비공개
            </button>
          </div>
        </div>
        <div className="write-btn-warp">
          <button type="submit" className="write-btn-warp_btn save">
            수정
          </button>
          <button type="reset" className="write-btn-warp_btn cancel">
            취소
          </button>
        </div>
      </form>
    </div>
  );
}
